import {
  CLEAR_UNIT_EVBOOST_OPERATION,
  CLEAR_UNIT_STORM_OPERATION,
  CREATE_UNIT_EVBOOST_OPERATION_FAILURE,
  CREATE_UNIT_EVBOOST_OPERATION_REQUEST,
  CREATE_UNIT_EVBOOST_OPERATION_SUCCESS,
  CREATE_UNIT_STORM_OPERATION_FAILURE,
  CREATE_UNIT_STORM_OPERATION_REQUEST,
  CREATE_UNIT_STORM_OPERATION_SUCCESS,
  DELETE_UNIT_EVBOOST_OPERATION_FAILURE,
  DELETE_UNIT_EVBOOST_OPERATION_REQUEST,
  DELETE_UNIT_EVBOOST_OPERATION_SUCCESS,
  DELETE_UNIT_STORM_OPERATION_FAILURE,
  DELETE_UNIT_STORM_OPERATION_REQUEST,
  DELETE_UNIT_STORM_OPERATION_SUCCESS,
  GET_SETTINGS_EVBOOST_OPERATION_FAILURE,
  GET_SETTINGS_EVBOOST_OPERATION_REQUEST,
  GET_SETTINGS_EVBOOST_OPERATION_SUCCESS,
  GET_SETTINGS_STORM_OPERATION_SUCCESS,
  GET_UNIT_EVBOOST_OPERATION_FAILURE,
  GET_UNIT_EVBOOST_OPERATION_REQUEST,
  GET_UNIT_EVBOOST_OPERATION_SUCCESS,
  GET_UNIT_STORM_OPERATION_FAILURE,
  GET_UNIT_STORM_OPERATION_REQUEST,
  GET_UNIT_STORM_OPERATION_SUCCESS,
  SET_UNIT_EVBOOST_OPERATION_LOAD_STATE,
  SET_UNIT_STORM_OPERATION_LOAD_STATE,
} from "actions/operation";

const initialState = {
  error: {},
  stormOperationLoading: false,
  stormOperation: {},
  stormOperationLoadState: "",
  evBoostOperationLoading: false,
  evBoostOperation: {},
  evBoostOperationLoadState: "",
  chargingOperation: {},
};

export default function operation(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case CREATE_UNIT_STORM_OPERATION_REQUEST:
    case GET_UNIT_STORM_OPERATION_REQUEST:
    case DELETE_UNIT_STORM_OPERATION_REQUEST: {
      return {
        ...state,
        stormOperationLoading: true,
      };
    }

    case CREATE_UNIT_STORM_OPERATION_SUCCESS: {
      return {
        ...state,
        stormOperationLoading: false,
        // stormOperation: payload,
      };
    }

    case GET_UNIT_STORM_OPERATION_SUCCESS: {
      return {
        ...state,
        stormOperationLoading: false,
        stormOperation: payload,
      };
    }

    case DELETE_UNIT_STORM_OPERATION_SUCCESS: {
      return {
        ...state,
        stormOperationLoading: false,
        // stormOperation: {},
      };
    }

    case CREATE_UNIT_STORM_OPERATION_FAILURE:
    case GET_UNIT_STORM_OPERATION_FAILURE:
    case DELETE_UNIT_STORM_OPERATION_FAILURE: {
      return {
        ...state,
        stormOperationLoading: false,
      };
    }

    case CLEAR_UNIT_STORM_OPERATION: {
      return {
        ...state,
        stormOperation: {},
      };
    }

    case GET_SETTINGS_STORM_OPERATION_SUCCESS: {
      const operation = payload.find((it) => it.battery === "storm");
      const chargingOperation = payload
        .filter((it) => it.ev1_charger)
        .find((it) => it.ev1_charger !== "boost");
      return {
        ...state,
        stormOperation: operation ?? {},
        chargingOperation: chargingOperation ?? {},
      };
    }

    case GET_SETTINGS_EVBOOST_OPERATION_SUCCESS: {
      const operation = payload.find((it) => it.ev1_charger === "boost");
      const chargingOperation = payload
        .filter((it) => it.ev1_charger)
        .find((it) => it.ev1_charger !== "boost");
      return {
        ...state,
        evBoostOperationLoading: false,
        evBoostOperation: operation ?? {},
        chargingOperation: chargingOperation ?? {},
      };
    }

    case CREATE_UNIT_EVBOOST_OPERATION_REQUEST:
    case GET_UNIT_EVBOOST_OPERATION_REQUEST:
    case DELETE_UNIT_EVBOOST_OPERATION_REQUEST:
    case GET_SETTINGS_EVBOOST_OPERATION_REQUEST: {
      return {
        ...state,
        evBoostOperationLoading: true,
      };
    }

    case CREATE_UNIT_EVBOOST_OPERATION_SUCCESS: {
      return {
        ...state,
        evBoostOperationLoading: false,
        // evBoostOperation: payload,
      };
    }

    case GET_UNIT_EVBOOST_OPERATION_SUCCESS: {
      return {
        ...state,
        evBoostOperationLoading: false,
        evBoostOperation: payload,
      };
    }

    case DELETE_UNIT_EVBOOST_OPERATION_SUCCESS: {
      return {
        ...state,
        evBoostOperationLoading: false,
        // evBoostOperation: {},
      };
    }

    case CREATE_UNIT_EVBOOST_OPERATION_FAILURE:
    case GET_UNIT_EVBOOST_OPERATION_FAILURE:
    case DELETE_UNIT_EVBOOST_OPERATION_FAILURE:
    case GET_SETTINGS_EVBOOST_OPERATION_FAILURE: {
      return {
        ...state,
        evBoostOperationLoading: false,
      };
    }

    case CLEAR_UNIT_EVBOOST_OPERATION: {
      return {
        ...state,
        evBoostOperation: {},
      };
    }

    case SET_UNIT_STORM_OPERATION_LOAD_STATE: {
      return {
        ...state,
        stormOperationLoadState: payload,
      };
    }

    case SET_UNIT_EVBOOST_OPERATION_LOAD_STATE: {
      return {
        ...state,
        evBoostOperationLoadState: payload,
      };
    }

    default:
      return state;
  }
}
